import React from 'react';
import WeatherForecast from '../../AccountHome/components/WeatherForecast';
import type { AlignedWeatherForecastProps } from '../riego.types';

const AlignedWeatherForecast: React.FC<AlignedWeatherForecastProps> = ({
  days,
  showHistoricalData = false,
}) => (
    <WeatherForecast
      hideTitle
      hideUpdateDate
      hideInfoSource
      specificDates={days}
      showHistoricalData={showHistoricalData}
      compact={true}
    />
);

export default AlignedWeatherForecast;
